//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "AlbumDates",

  data() {
    return {
      maximizedToggle: true,
    };
  },

  components: {},

  computed: {
    dialog: {
      get() {
        return this.$store.state.monuments.albumDatesDialog;
      },
      set: function () {
        this.$store.dispatch("monuments/toggleAlbumDatesDialog");
      }
    },

    photoAlbums() {
      return this.$store.getters["monuments/getSelectedItemPhotoAlbums"];
    },
  },

  methods: {
    selectedDateAlbum(selectedDate) {
      // console.log('@AlbumDates.vue :: @selectedDateAlbum >> selected date: ', selectedDate);
      return this.photoAlbums.filter(item => item.date === selectedDate)[0];
    },

    openAlbumSections: (vueStore, selectedDate) => {
      // console.log('@AlbumDates.vue :: @openAlbumSections >> selectedDate: ', selectedDate);
      vueStore.dispatch("monuments/toggleAlbumSectionsDialog", selectedDate);
    },

    openAlbumPhotoGallery: (vueStore) => {
      // console.log('@AlbumDates.vue :: @openAlbumPhotoGallery');
      vueStore.dispatch("monuments/toggleAlbumPhotoGalleryDialog");
    },

    openNext: function (selectedDate) {
      // console.log('@AlbumDates.vue :: @openNext >> selected date: ', selectedDate);
      // set new date
      this.$store.dispatch("monuments/setAlbumSelectedDate", selectedDate);

      // next step for selected date
      // console.log('selectedDateAlbum: ', this.selectedDateAlbum(selectedDate));
      const sectionsLength = this.selectedDateAlbum(selectedDate).sections.length;
      // console.log('@AlbumDates.vue :: @openNext >> selectedItem.PhotoAlbums.sections.length: ', sectionsLength);
      if (sectionsLength === 1) {
        this.openAlbumPhotoGallery(this.$store);
      } else {
        this.openAlbumSections(this.$store);
      }
    },

  },
}
